import React from 'react'
import Text from '../Text'
import styles from './styles.module.css'

function CounterIndication({ children }) {
  return (
    <div className={styles.wrapper}>
      <Text type="tiny"><div className={styles.indication}>{children}</div></Text>
    </div>
  )
}

export default CounterIndication
